import { render, staticRenderFns } from "./shopEdit.vue?vue&type=template&id=4f0a8dd7&"
import script from "./shopEdit.vue?vue&type=script&lang=js&"
export * from "./shopEdit.vue?vue&type=script&lang=js&"
import style0 from "./shopEdit.vue?vue&type=style&index=0&id=4f0a8dd7&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports